import { Link } from "react-router-dom";
import { cldImage } from "@/lib/cldImage";
import DietaryMark from "@/components/site/DietaryMark";

export default function ProductCard({ product }) {
  const rawSrc = product.image_url?.startsWith("/api/")
    ? `${process.env.REACT_APP_BACKEND_URL}${product.image_url}`
    : product.image_url;
  const imageSrc = cldImage(rawSrc, { w: 600 });
  const isTrackedProduct = ["cups", "tubs"].includes(product.category);
  const isSoldOut = (
    isTrackedProduct
    && typeof product.stock_qty === "number"
    && product.stock_qty <= 0
  );
  const isUnavailable = !product.is_available && !isSoldOut;

  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block"
    >
      <div className="relative overflow-hidden bg-ivory-100 aspect-[4/3]">
        {imageSrc && (
          <img
            src={imageSrc}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.04]"
          />
        )}
        {isSoldOut && (
          <div
            data-testid={`sold-out-overlay-${product.slug}`}
            className="absolute inset-0 flex items-center justify-center bg-espresso/55"
          >
            <span className="border border-ivory bg-espresso px-4 py-2 text-xs font-semibold tracking-[0.16em] text-ivory">
              SOLD OUT
            </span>
          </div>
        )}
        {isUnavailable && (
          <div className="absolute inset-0 flex items-center justify-center bg-ivory/70">
            <span className="label-xs text-espresso">Currently unavailable</span>
          </div>
        )}
        {product.is_available && typeof product.stock_qty === "number" && product.stock_qty > 0 && product.stock_qty <= 5 && (
          <div className="absolute top-3 left-3 bg-espresso text-ivory label-xs px-2.5 py-1 rounded-full shadow-sm" data-testid={`low-stock-${product.slug}`}>
            Only {product.stock_qty} left!
          </div>
        )}
      </div>
      <div className="mt-3 flex items-start justify-between gap-2 md:mt-5 md:gap-4">
        <div>
          <div className="flex items-center gap-2">
            <h3 className="font-serif text-xl font-bold leading-none text-espresso md:text-2xl">
              {product.name}
            </h3>
            <DietaryMark
              dietaryType={product.dietary_type}
              testId={`dietary-symbol-${product.slug}`}
            />
          </div>
          {product.description && (
            <p className="mt-2 hidden max-w-xs text-sm font-normal leading-relaxed text-espresso-light line-clamp-2 sm:block">
              {product.description}
            </p>
          )}
        </div>
        <div className="pt-0.5 font-serif text-base font-bold whitespace-nowrap text-espresso md:pt-1 md:text-xl">
          ₹{product.price}
        </div>
      </div>
    </Link>
  );
}
